import { getReactRendererFromState } from '../../../../extensions/behavior';
import { AutocompletePopupCloser } from '../../../../utils/autocomplete-popup';
import { ArrayCarousel } from '../../../../utils/carousel';
import { AutocompleteActionKind, closeAutocomplete, } from '../../../behavior/Autocomplete';
import { EmojiConsts } from '../EmojiSpecs';
import { render } from './EmojiSuggestComponent';
import { findDecoElem } from './utils';
const emptyArray = new Array(0);
export class EmojiHandler {
    constructor({ defs, shortcuts = {} }) {
        this.onItemClick = (index) => {
            var _a;
            if (this._emojiCarousel) {
                this._emojiCarousel.currentIndex = index;
                this.select();
            }
            (_a = this._view) === null || _a === void 0 ? void 0 : _a.focus();
        };
        this._emojis = Object.entries(defs).map(([name, symbol]) => {
            const def = { symbol, origName: name, name: name.toLowerCase() };
            const short = shortcuts[name];
            if (short) {
                def.origShortcuts = emptyArray.concat(short);
                def.shortcuts = def.origShortcuts.map((val) => val.startsWith(':') ? val.slice(1) : val);
            }
            return def;
        });
    }
    onOpen(action) {
        this.findAnchor();
        if (!this._anchor) {
            this.closeAutocomplete(action.view);
            return true;
        }
        this._popupCloser = new AutocompletePopupCloser(action.view);
        this.updateState(action);
        this.filterActions();
        this.render();
        return true;
    }
    onFilter(action) {
        var _a, _b;
        if ((_a = action.filter) === null || _a === void 0 ? void 0 : _a.endsWith('  ')) {
            this.closeAutocomplete(action.view);
            return true;
        }
        this.updateState(action);
        const needToClose = this.filterActions((_b = action.filter) === null || _b === void 0 ? void 0 : _b.trim());
        this.render();
        if (needToClose) {
            this.closeAutocomplete(action.view);
        }
        return true;
    }
    onArrow(action) {
        this.updateState(action);
        if (!this._emojiCarousel)
            return false;
        switch (action.kind) {
            case AutocompleteActionKind.up: {
                this._emojiCarousel.prev();
                break;
            }
            case AutocompleteActionKind.down: {
                this._emojiCarousel.next();
                break;
            }
            default:
                return false;
        }
        this.render();
        return true;
    }
    onEnter(action) {
        this.updateState(action);
        this.select();
        return true;
    }
    onClose(action) {
        this.updateState(action);
        this.clear();
        return true;
    }
    onDestroy() {
        this.clear();
    }
    closeAutocomplete(view) {
        setTimeout(() => {
            closeAutocomplete(view);
        });
    }
    select() {
        var _a;
        const { _view: view, _range: range } = this;
        if (!view || !range)
            return;
        const emojiDef = (_a = this._emojiCarousel) === null || _a === void 0 ? void 0 : _a.currentItem;
        if (!emojiDef)
            return;
        const { tr, schema } = view.state;
        view.dispatch(tr.replaceWith(range.from, range.to, createEmoji(schema, emojiDef)).scrollIntoView());
        view.focus();
    }
    filterActions(inputText) {
        var _a;
        const currentItem = (_a = this._emojiCarousel) === null || _a === void 0 ? void 0 : _a.currentItem;
        let filteredEmojis = this._emojis;
        let needToClose = false;
        if (inputText) {
            filteredEmojis = filterEmojis(filteredEmojis, inputText);
            needToClose = !filteredEmojis.length && needToHide(this._emojis, inputText);
        }
        this._emojiCarousel = new ArrayCarousel(filteredEmojis);
        if (currentItem) {
            const newIndex = this._emojiCarousel.array.findIndex((item) => item === currentItem);
            if (newIndex !== -1) {
                this._emojiCarousel.currentIndex = newIndex;
            }
        }
        return needToClose;
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        this.findAnchor();
        const viewItems = (_b = (_a = this._emojiCarousel) === null || _a === void 0 ? void 0 : _a.array) !== null && _b !== void 0 ? _b : [];
        this._suggestProps = {
            anchor: this._anchor,
            currentIndex: (_c = this._emojiCarousel) === null || _c === void 0 ? void 0 : _c.currentIndex,
            items: viewItems,
            onClick: this.onItemClick,
            onEscapeKeyDown: (_d = this._popupCloser) === null || _d === void 0 ? void 0 : _d.popupEscapeKeyHandler,
            onOutsideClick: (_e = this._popupCloser) === null || _e === void 0 ? void 0 : _e.popupOutsideClickHandler,
        };
        this._suggestRenderItem = (_f = this._suggestRenderItem) !== null && _f !== void 0 ? _f : this.createMenuRenderItem();
        this._suggestRenderItem.rerender();
    }
    updateState({ view, range }) {
        this._view = view;
        this._range = range;
    }
    clear() {
        var _a, _b;
        this._view = undefined;
        this._range = undefined;
        this._anchor = undefined;
        this._emojiCarousel = undefined;
        (_a = this._popupCloser) === null || _a === void 0 ? void 0 : _a.cancelTimer();
        this._popupCloser = undefined;
        this._suggestProps = undefined;
        (_b = this._suggestRenderItem) === null || _b === void 0 ? void 0 : _b.remove();
        this._suggestRenderItem = undefined;
    }
    createMenuRenderItem() {
        return getReactRendererFromState(this._view.state).createItem('emoji_suggest', () => this._suggestProps ? render(this._suggestProps) : null);
    }
    findAnchor() {
        var _a;
        this._anchor = findDecoElem((_a = this._view) === null || _a === void 0 ? void 0 : _a.dom);
    }
}
function createEmoji(schema, def) {
    return EmojiConsts.nodeType(schema).create({ [EmojiConsts.NodeAttrs.Markup]: def.name }, schema.text(def.symbol));
}
function filterEmojis(defs, text) {
    var _a;
    if (!text)
        return defs;
    const textLowerCase = text.toLowerCase();
    const byShortcuts = [];
    const byName = [];
    for (const emoji of defs) {
        if ((_a = emoji.shortcuts) === null || _a === void 0 ? void 0 : _a.some((val) => val.startsWith(text))) {
            byShortcuts.push(emoji);
        }
        else if (emoji.name.startsWith(textLowerCase)) {
            byName.push(emoji);
        }
    }
    return byShortcuts.concat(byName);
}
const CHARS_TO_HIDE = 4;
function needToHide(defs, text) {
    let iter = 1;
    do {
        const prevInput = text.slice(0, text.length - iter);
        const prevActions = filterEmojis(defs, prevInput);
        if (prevActions.length)
            break;
        iter++;
    } while (iter < text.length && iter < CHARS_TO_HIDE);
    return iter >= CHARS_TO_HIDE;
}
